import { ready } from '../utils/readyinit';
import initCartUpsellAtc from '../components/cart-upsell-atc';
import initCartPage from '../sections/cart/initCartPage';

ready(() => {
  initCartUpsellAtc();
  initCartPage();
});
